import PotentiometerDiagram from "../../../../docs/_images/hw_ff_potentiometer.png";
import PotentiometerSchematics from "../../../../docs/_images/hw_ff_potentiometer_schem.png";
import PotentiometerLedDiagram from "../../../../docs/_images/hw_ff_potentiometer_led.png";
import * as React from 'react';
export default {
  PotentiometerDiagram,
  PotentiometerSchematics,
  PotentiometerLedDiagram,
  React
};